import Panelenterprise from '../panelenterprise/panelenterprise.vue'
import Typeaddressenterprise from '../typeaddressenterprise/typeaddressenterprise.vue'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import Boardmediaenterprise from '../boardmediaenterprise/boardmediaenterprise.vue'
import Mirrorsalesenterprise from '../mirrorsalesenterprise/mirrorsalesenterprise.vue'
import { loading } from '@/shared/utils/UIHelper'
import Tabenterprise from '../tabenterprise/tabenterprise.vue'
import Evolutionwork from '../evolutionwork/evolutionwork.vue'
import Towerscourt from '../towerscourt/towerscourt.vue'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import Tableprice from '../tableprice/tableprice.vue'

const tabIndex = {
  typeende: 0,
  midi: 1,
  espelhove: 2,
  pricetable: 3,
  evolutionwork: 4,
  towercourt: 5,
  realestate: 6
}

export default {
  name: 'Detailsenterprise',
  props: ['data', 'id'],
  components: {Panelenterprise, Typeaddressenterprise, HeadDetailsGama, Boardmediaenterprise, Mirrorsalesenterprise, Evolutionwork, Tabenterprise, Towerscourt, Tableprice},
  data () {
    return {
      tabIndex: tabIndex.typeende
    }
  },
  methods: {
    saveEnterprise () {
      loading.push()
      EnterpriseRepository.Create(this.data)
        .then(Response => loading.pop())
        .catch(Error => loading.pop())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/detailsenterprise/detailsenterprise.js